// @flow
import React, { type Node } from 'react';


export type MonthItemProps = {
  className?: string,
  id: string,
  month: number,
  year: number,
}

const MonthItem = ({
  className,
  // id,
  month,
  year,
}: MonthItemProps): Node => {
  return (
    <div className={className}>
      {month}
      <span className="visuallyHidden">{year}</span>
    </div>
  );
};

export default MonthItem;
